<template>
    <v-card>
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar">
            {{callbackResponse.message}}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <v-toolbar class="darken-4" color="indigo" dark>
            <v-toolbar-title>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <div>
            <div>
                <h2 style="text-align:center">{{logData.viewShow}} आ.ब.{{logData.yearName}} को {{reportTitle}}</h2>
                <table class="table tbl">
                    <thead v-if="groupLevel==1 || groupLevel==2">
                        <tr>
                            <th rowspan="2">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" v-bind:key="index"
                                    v-if=" header.groupID > 0 ">
                                    <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>
                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ header.groupName }}</span>

                                </th>
                                <template v-else>
                                    <template v-for="(column, index) in header.subList">
                                        <th rowspan="2" style="text-align:center" v-bind:key="index">
                                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--END NEW-->
                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                    </template>

                                </template>
                            </template>
                        </tr>

                        <tr>
                            <template v-for="(column, index) in colsHeaders">
                                <th :key="index" style="text-align:center" v-if=" column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>
                    <thead v-if="groupLevel==3">
                        <tr>
                            <th rowspan="3">क्र सं</th>
                            <template v-for="(header,index) in headers">
                                <th :colspan="header.listCount" style="text-align:center" v-bind:key="index"
                                    v-if="header.groupID>0 ">


                                    <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                         आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}  
                                    </span>
                                    <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                          आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                          आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                          आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                                    </span>
                                    <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                          आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                                    </span>
                                    <!--END NEW-->
                                    <span v-else> {{ header.groupName }}</span>
                                </th>
                                <template v-else>
                                    <template v-for="(column, index) in header.list">
                                        <th :colspan="column.subList.length" rowspan="2" style="text-align:center"
                                            v-bind:key="index" v-if="header.groupID>0">
                                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                                   आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                   आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                  आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>

                                            <!--NEW-->
                                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                                   आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                            </span>
                                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                                  आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                            </span>
                                            <!--END NEW-->
                                            <span v-else> {{ column.name }}</span>
                                        </th>
                                        <template v-else v-for="(subColumn, index) in column.subList">
                                            <th rowspan="3" style="text-align:center" v-bind:key="index">
                                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                                       आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                       आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                       आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>
                                                <!--NEW-->
                                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                      आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                                </span>
                                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                                </span>
                                                <!--END NEW-->
                                                <span v-else> {{ subColumn.name }}</span>
                                            </th>
                                        </template>
                                    </template>

                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column, index) in subColumns">
                                <th :colspan="column.subList.length" :key="index" style="text-align:center"
                                    v-if="column.groupID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                         आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                          आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                          आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>
                                    <!--NEW-->

                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                           आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                           आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                                    </span>

                                    <!--END NEW-->
                                    <span v-else> {{ column.groupName }}</span>
                                </th>
                                <template v-for="(subColumn, index) in column.subList">
                                    <th :key="index" rowspan="2" style="text-align:center"
                                        v-if="subColumn.titleID>0 && column.groupID==null">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>
                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                               आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>
                                        <!--END NEW-->
                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr>
                            <template v-for="(column,index) in colsHeaders">
                                <th :key="index" style="text-align:center" v-if="column.subTitleID>0 ">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                          आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                           आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->


                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>
                        </tr>
                    </thead>

                    <template v-for="(section,index) in rows">
                        <tr :key="index">
                            <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                                <span> {{index+1}}. {{section.reportSection}}</span>
                            </td>
                        </tr>
                        <template v-for="(subSection,index) in section.list">
                            <tr :key="index">
                                <td style="text-align:center">{{index+1}}</td>
                                <td style="text-align:center">{{subSection.reportSubSection}}</td>
                                <td :key="index" class="data-input" style="text-align:center"
                                    v-for="(rowsHeader, index) in subSection.list">
                                    <v-text-field @keypress="isNumber($event)" label="Amount" outlined
                                                  v-if="rowsHeader.dataType==2" v-model="rowsHeader.amount"
                                                  v-on:input="calculateTotal()" readonly></v-text-field>
                                    <v-text-field @keypress="isNumber($event)" label="Quantity" outlined
                                                  v-else-if="rowsHeader.dataType==4" v-model="rowsHeader.amount"
                                                  v-on:input="calculateTotal()" readonly></v-text-field>
                                    <v-text-field dense @keypress="isNumber($event)" label="Quantity 1" outlined
                                                  v-else-if="rowsHeader.dataType==6" v-model="rowsHeader.amount"
                                                  v-on:input="calculateTotal()"></v-text-field>
                                    <v-text-field @keypress="isNumber($event)" label="Total" outlined
                                                  v-else-if="rowsHeader.dataType==5"
                                                  v-model="rowsHeader.amount" readonly></v-text-field>
                                    <v-text-field label="Text" outlined v-else v-model="rowsHeader.value" readonly></v-text-field>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tfoot>
                        <tr class="tfoot">
                            <td colspan="2"><b>Total</b></td>
                            <td :key="total" v-for="total in totals">
                                <b v-if="total.total>0">{{total.total}}</b>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </v-card>

</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";

    export default {
        name: 'ApprovedComponent',
        watch: {
            "logData": {
                handler: async function () {
                    this.$emit("logDataResponse", this.logData)
                },
                deep: true
            },
        },
        computed: {
            isCompany() {
                let check = this.role == "SuperAdmin"
                return check
            },
            isDepartment() {
                let check = this.role == "Company" || this.role == "SuperAdmin"
                return check
            },
            isBranch() {
                let check = this.role == "Company" || this.role == "SuperAdmin" || this.tokenData.role == "Department"
                return check
            },
            companyIDErrors() {
                const errors = [];
                if (!this.$v.logData.companyID.$dirty) return errors;
                !this.$v.logData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.logData.year.$dirty) return errors;
                !this.$v.logData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
        },
        props: ['approvebtnData'],
        components: {},
        data() {
            return {
                panelData: [0, 1],
                selectedStatus: {
                    company: "",
                    branch: ""
                },
                error: false,
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                listDDLData: {
                    companyList: [],
                    departmentList: [],
                    branchList: [],
                    depoList: []
                },
                status: {
                    isCompany: false,
                    isDepartment: false,
                },
                snackbar: false,
                table: false,
                dialogCreate: false,
                breadCrumbs: [],
                IsActive: false,
                TotalHeaderIndex: 0,
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                reportList: [],
                reportLogs: [],
                subColumns: [],
                yearList: [],
                tableFormData: [],
                helpData:[],
                logData: this.$route.query,
                serverData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    reportID: parseInt(this.$route.params.id),
                    year: "",
                    reportLogID: 0
                },
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "reportID",
                            type: "desc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                role: this.$store.getters.getUserRole,
                userData: this.$store.getters.getUserData,
                yearShow: "",
                valueShow: "",
                setYearValue: "",
                setAllValue: "",
                submitStatus: "",
                YearPreviousCurrentNext: {},
                groupedRows: [],
                color: ""
            };
        },
        validations: {
            logData: {
                companyID: {required},
                year: {required},
            }
        },
        mounted() {
            this.getData();
        },

        methods: {
            dialogueClose() {
                this.dialog = true
                this.$emit("formResponse", this.dialog);
            },
            
            getData() {
                console.log("comp",this.approvebtnData)
                let data={
                    reportID: parseInt (this.approvebtnData.reportID),
                    reportLogID: parseInt(this.approvebtnData.reportLogID),
                    year: this.approvebtnData.year,
                    isApproved:true
                }
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                    const currentYearIndex = this.indexWhere(this.yearList, item => item.value === data.year)

                    let previousThreeYearIndex = currentYearIndex - 3;
                    let previousTwoYearIndex = currentYearIndex - 2;
                    let previousYearIndex = currentYearIndex - 1;
                    let nextYearIndex = currentYearIndex + 1;
                    let previousCurrentNext = {};

                    this.yearList.forEach(function (data, yearIndex) {


                        if (currentYearIndex == yearIndex) {
                            previousCurrentNext.current = data.id
                        }
                        //NEW
                        if (previousTwoYearIndex == yearIndex) {
                            previousCurrentNext.twoYear = data.id
                        }
                        if (previousThreeYearIndex == yearIndex) {
                            previousCurrentNext.threeYear = data.id
                        }
                        //end NEW
                        if (previousYearIndex == yearIndex) {
                            previousCurrentNext.previous = data.id
                        }
                        if (nextYearIndex == yearIndex) {
                            previousCurrentNext.next = data.id
                        }

                    })
                    if (data.depoID == "") {
                        data.depoID = null
                    }
                    this.YearPreviousCurrentNext = previousCurrentNext;
                })
               


                this.getColsRow(data);
            },
         
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            setValue(data, type) {
                if (type == "Company") {
                    this.logData.departmentID = "";
                    this.logData.branchID = "";
                }
                if (type == "Department") {
                    this.logData.branchID = "";
                }
                if (type == "Branch") {
                    this.departmentSelectedCompany('depo')
                    this.logData.departmentID = "";
                    this.selectedStatus.branch = ""
                }
            },

            setValueYear(data) {
                var year = this.yearList.filter(function (item) {
                    return item.value === data;
                });
                this.setYearValue = year[0].id;
            },


            getColsRow(data) {
                axios.post('ReportSettings/GetColsRows', data).then(response => {
                    this.rows = response.data.rows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                    this.logData.viewShow = response.data.company;
                    this.logData.yearName = response.data.year;

                    this.serverData.companyID = response.data.companyID;
                    this.serverData.departmentID = response.data.departmentID;
                    this.serverData.branchID = response.data.branchID;
                    this.serverData.depoID = response.data.depoID;
                    this.serverData.reportID = data.reportID;
                    this.serverData.year = response.data.year;
                    this.serverData.reportLogID =data.reportLogID;
                })
            },

            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },


            nullTitle(title) {
                return title == null
            },

            branchData() {
                axios.get("Branch/DDLBranchList", {
                    params: {
                        companyID: this.logData.companyID
                    }
                }).then(response => {
                    this.listDDLData.branchList = response.data
                })
            },

            depoData() {
                this.listDDLData.depoList = []
                axios.get("Depo/DDLDepoList", {
                    params: {
                        branchID: this.logData.branchID
                    }
                }).then(response => {
                    this.listDDLData.depoList = response.data
                })
            },

            updateReportData() {
                var tableFormData = [];
                this.rows.forEach(function (data) {
                    data.list.forEach(function (list) {
                        list.list.forEach(function (amount) {
                        //    if (parseFloat(amount.amount) > 0 || (amount.value != "")) {
                                amount.amount = parseFloat(amount.amount);
                                tableFormData.push(amount);
                         //   }
                        })
                    })
                })
                let logData = {
                    "companyID": this.serverData.companyID,
                    "departmentID": this.serverData.departmentID,
                    "branchID": this.serverData.branchID,
                    "depoID": this.serverData.depoID,
                    "reportID": parseInt(this.serverData.reportID),
                    "year": this.serverData.year,
                    "list": tableFormData,
                    "reportLogID": this.serverData.reportLogID == "" ? 0 : parseInt(this.serverData.reportLogID)
                }
                axios.post("ReportSettings/InsertOrUpdateActualReportDataAsync", logData).then(response => {
                    if (response.data.success) {
                        this.logData.reportLogID = response.data.id;
                        this.status = "success"
                        this.color = "success"
                        this.snackbar = true
                        this.callbackResponse.message = "Data updated successfully."
                        this.reportLog()
                    }
                })
            },

            calculateTotal: function () {
                //footer total
                let AllRows = [];

                //subTitleID //titleID
                this.rows.forEach(function (section) {
                    section.list.forEach(function (subsection) {
                        subsection.list.forEach(function (amount) {
                            let amountToCal = 0;
                            var matchedData = subsection.list.filter(function (data) {
                                return (data.titleID == amount.titleID && data.subTitleID == amount.subTitleID)
                            });
                            if (matchedData.length > 0) {
                                let AmountList = matchedData.filter(function (data) {
                                    return (data.dataType == 2);
                                });
                                if (AmountList.length > 0) {
                                    amountToCal = AmountList.reduce((acc, item) => acc + parseFloat(item.amount), 0);
                                }
                                if (amount.dataType == 5) {
                                    let Quantity = matchedData.find(x => x.dataType === 4);
                                    let Quantity1 = matchedData.find(x => x.dataType === 6);

                                    amount.amount = 0;
                                    if (Quantity != undefined) {
                                        if (parseFloat(Quantity.amount) > 0) {
                                            amount.amount = parseFloat(Quantity.amount) * amountToCal;
                                            if (Quantity1 != undefined) {
                                                if (parseFloat(Quantity1.amount) > 0) {
                                                    amount.amount = parseFloat(Quantity1.amount) * amount.amount;
                                                } else {
                                                    amount.amount;
                                                }
                                            } else {
                                                amount.amount;
                                            }
                                        } else {
                                            amount.amount = amountToCal;
                                        }
                                    } else {
                                        amount.amount = amountToCal;
                                    }


                                    amount.amount = amount.amount.toFixed(2);
                                }
                                if (parseFloat(amount.amount) > 0) {
                                    AllRows.push(
                                        {
                                            "reportHeaderID": amount.reportHeaderID,
                                            "amount": parseFloat(amount.amount)
                                        });
                                }
                            }

                        })
                    })
                })
                this.totals.forEach(function (data) {
                    data.total = 0;
                    var match = AllRows.filter(function (item) {
                        return item.reportHeaderID === data.headerID;
                    }).reduce((total, amount) => {
                        return total + parseFloat(amount.amount)
                    }, 0);
                    data.total = parseFloat(match);
                    data.total = data.total.toFixed(2);
                })
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.reportLog();
            },

            onPerPageChange(params) {
                this.serverParams.page = 1
                this.updateParams({perPage: params.currentPerPage});
                this.reportLog();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.reportLog();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.reportLog();
            },

        }
    };
</script>

<style lang="scss" scoped>

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }

    .tbl {

        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: $main-color;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        table-layout: fixed;
        border-collapse: collapse;
        width: 100%;

    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .data-input {
        .v-input {
            max-width: 7.1em !important;
        }
    }

    input {
        max-width: 5.7em !important;
    }

    .employee-form-header {
        background-color: $main-color;
        height: 3em;
        padding: .6em;

        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }

    #form_card {
        text-align: center;
    }

    .box-border {
        border: 1px solid;
        padding: 1em;
    }
</style>
